// extracted by mini-css-extract-plugin
module.exports = {"phaseApprovalCardDelete":"_3MPdEQvkj9JJUXIUjS3Xry","phaseApprovalCard":"ti-NP636zTiJd0VJFGQEk"};